import { FC, HTMLAttributes } from 'react';

import styled from '@emotion/styled';

import { ReadonlyField as ReadonlyFieldBase } from '@britishcouncil/react-solas-ors3';

export const ReadonlyField: FC<{ label: string; horizontal?: boolean } & HTMLAttributes<HTMLDListElement>> = ({
  children,
  ...props
}) => <StyledReadonlyField {...props}>{!children ? '-' : children}</StyledReadonlyField>;

const StyledReadonlyField = styled(ReadonlyFieldBase)`
  @media (min-width: 850px) {
    dt {
      font-size: 1.11em;
      width: 200px;
    }
  }
`;
